import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'components/Root';
import configureStore from './stores';
// import createBrowserHistory from 'history/lib/createBrowserHistory';

import initialState from './stores/initial-state';
import {resetAnimation} from './action-creators';

const target = document.getElementById('root');
const store  = configureStore(initialState);

store.dispatch(resetAnimation());

// const node = <Root routerHistory={createBrowserHistory()} store={store}/>;
const node = <Root store={store}/>;
ReactDOM.render(node, target);



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/index.js
 **/